// Quote mobile slider
new Splide('#quote_slider', {
    perPage: 2,
    perMove: 1,
    gap: 32,
    arrows: true,
    pagination: true,
    arrowPath: 'M0 7.00008V9.00008H12L6.5 14.5001L7.92 15.9201L15.84 8.00008L7.92 0.0800781L6.5 1.50008L12 7.00008H0Z',
    padding: {left: '0rem', right: '0rem'},

    breakpoints: {
        600: {
            perPage: 1,
            padding: {left: '1.5rem', right: '3rem'},
        },
        728: {
            perPage: 1,
            padding: {left: '2rem', right: '4rem'},
        },

    },
    classes: {
        arrows: 'splide__arrows container-contrl px-6 sm:px-8 md:px-0 -bottom-16 absolute z-10 justify-end flex gap-4',
        arrow: 'splide__arrow items-center',
        prev: 'splide__arrow--prev left-1 bg-white/10',
        next: 'splide__arrow--next right-1 bg-white/10',
        // Add classes for pagination.
        pagination: 'splide__pagination px-6 sm:px-8 md:px-0 !block !-bottom-12', // container
        page: 'splide__pagination__page !w-8 !h-[0.3rem] rounded-sm', // each button
    },
}).mount();
